import { fetchEntityEntitlements } from '../services/entityApi';
import type { EntityApplication, Logger } from '../types';

export function activeEntityEntitlementsQueryKey(userUuid: string, friendlyId: string) {
  return ['activeEntityEntitledApplications', userUuid, friendlyId] as const;
}

export function activeEntityEntitlementsQueryOptions({
  userUuid,
  friendlyId,
  getAccessTokenSilently,
  logger,
}: {
  userUuid: string;
  friendlyId: string;
  getAccessTokenSilently: () => Promise<string>;
  logger: Logger;
}) {
  return {
    queryKey: activeEntityEntitlementsQueryKey(userUuid, friendlyId),
    queryFn: async (): Promise<EntityApplication[]> => {
      const token = await getAccessTokenSilently();
      return fetchEntityEntitlements(userUuid, friendlyId, token, logger);
    },
    staleTime: 2 * 60 * 1000,
    gcTime: 24 * 60 * 60 * 1000,
    refetchOnMount: false,
    refetchOnReconnect: false,
    retry: 1,
  };
}
